import React from "react";
import "./Hero.css";
import myVideo from "../assets/BrandVideo.mp4";

const Hero = () => (
  <div className="hero-container" id = "home">
    <video
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      webkit-playsinline="true"
      className="hero-video"
    >
      <source src={myVideo} type="video/mp4" />
    </video>
  </div>
);

export default Hero;
